import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CivicBudgetState } from '../reducers/civic-budget.reducer';

export const selectCivicBudgetState = createFeatureSelector<CivicBudgetState>('civicBudgets');

export const selectLoading = createSelector(selectCivicBudgetState, state => state.loading > 0);

export const selectPending = createSelector(selectCivicBudgetState, state => state.pending > 0);

export const selectBudgets = createSelector(selectCivicBudgetState, state => state.budgets);

export const selectBudgetById = (id: string) => createSelector(selectBudgets, budgets => budgets.filter(b => b.id === id).at(0) || null);
